const actionTypes = {
  SET: 'qna/set',
  SET_ERROR: 'qna/error',
};

export default actionTypes;
